import { render, staticRenderFns } from "./AutorizationTable.vue?vue&type=template&id=4e744707&scoped=true&"
import script from "./AutorizationTable.vue?vue&type=script&lang=js&"
export * from "./AutorizationTable.vue?vue&type=script&lang=js&"
import style0 from "./AutorizationTable.vue?vue&type=style&index=0&id=4e744707&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e744707",
  null
  
)

export default component.exports